<template>
  <v-card>
    <v-card-title>{{ $t("applicationCycles.title") }}</v-card-title>
    <v-card-text>
        <v-data-table
            :headers="headers"
            :items="this.$store.getters.competition.applicationCycles"
            disable-sort
            disable-pagination
            hide-default-headers
            hide-default-footer>
          <template v-slot:item.applicationType="{item}">
            <a @click="showDialog(item)">
              {{ applicationType(item.applicationType) }}
            </a>
          </template>
          <template v-slot:item.startTime="{item}">
            {{ item.startTime | datetime }}
          </template>
          <template v-slot:item.endTime="{item}">
            {{ item.endTime | datetime }}
          </template>
          <template v-slot:item.amount="{item}">
            {{ item.amount }} €
          </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="showDialog({})" color="success">
        {{ $t("ctrl.add") }}
      </v-btn>
    </v-card-actions>
    <ApplicationCycle ref="dialog" />
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import ApplicationCycle from '../../dialogs/ApplicationCycle.vue'


  export default {
    name: 'FCCCompetitionApplicationCycles',
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      headers: function(){
        return [
            { text: this.$t("application.type"), value: "applicationType"},
            { text: this.$t("applicationCycles.startTime"), value: "startTime"},
            { text: this.$t("applicationCycles.endTime"), value: "endTime"},
            { text: this.$t("applicationCycles.amount"), value: "amount"}
        ]
      }
    },
    methods: {
        applicationType: function(i) {
            return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
        },
        showDialog: function(id){
          this.$refs.dialog.show(id);
        }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        ApplicationCycle
    },    
  }
</script>